function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/) );
//requireAll( require.context( './png/', true, /\.png$/) );
//requireAll( require.context( './gif/', true, /\.gif$/) );
requireAll( require.context( './fonts/', true ) );

import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import objectFitImages from 'object-fit-images';
import Headroom from 'headroom.js';
import HappyFocus from 'happy-focus';
import Mustache from 'mustache';
import Swiper from 'swiper/js/swiper.min.js';
import ScrollReveal from 'scrollreveal';
import simpleSocialShare from './js/vendor/simpleSocialShare.js';
import tabsList from '../vendor/tabslist/src/assets/tabsList.js';
import Sortable from 'sortablejs';

require( 'es6-object-assign/auto' );

$(function () {

	var PROJECT = {

		common: {

			getViewport: function() {

				var viewPortWidth;
				var viewPortHeight;

				if (typeof window.innerWidth !== 'undefined') {

					viewPortWidth = window.innerWidth;
					viewPortHeight = window.innerHeight;

				} else if ( typeof document.documentElement !== 'undefined' &&
							typeof document.documentElement.clientWidth !== 'undefined' &&
							document.documentElement.clientWidth !== 0 ) {

					viewPortWidth = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;

				} else {

					viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
					viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
				}

				return { width : viewPortWidth , height : viewPortHeight };

			},

			init: function () {

				objectFitImages();

				const happyfocus = new HappyFocus();

				PROJECT.nav.init();

				PROJECT.accordion.init();

				PROJECT.list.init();

				PROJECT.gform.init();

				PROJECT.video.init();

				PROJECT.lightbox.init();
				
				PROJECT.sliders.init();

				PROJECT.tooltip.init();

				PROJECT.scroll.init();

				PROJECT.account.init();

				PROJECT.login.init();

				PROJECT.talent.init();

				PROJECT.price.init();

				window.tabsList.init();
				
				window.simpleSocialShare.init('.socialShareBtn');

			}

		},

		nav: {

			init: function() {

				$( document ).on( 'click', '.jsSubnavToggle', {

					class: 'c-header--subnav-open',
					classElement: '.jsHeader',
					navElement: '.jsSubnavItems',

				}, PROJECT.accordion.toggle );

				$( document ).on( 'click', '.c-mobile-nav__nav .v-nav__item--has-children > a', {

					class: 'v-nav__item--submenu-open',
					classElement: '.v-nav__item',
					navElement: '.sub-menu',

				}, PROJECT.accordion.toggle );

				$( document ).on( 'click', '.jsMobileNavToggle', PROJECT.nav.toggle );


				$( document ).on( 'mouseenter mouseover', '.v-nav--main > .v-nav__item--has-children', function() {

					$( 'html' ).addClass( 'state-c-nav--open' );

				} );
				$( document ).on( 'mouseleave', '.v-nav--main > .v-nav__item--has-children', function() {

					$( 'html' ).removeClass( 'state-c-nav--open' );

				} );

				PROJECT.nav.headroom();

			},

			headroom: function() {

				var body = $( 'html' ).get( 0 );
				
				var headerOffset = 88;
				
				var headerSticky = new Headroom( body, {

					offset: headerOffset,
					tolerance : {

						up : 5,
						down : 0

					},
					classes : {

						initial : "state-c-header--init",
						pinned : "state-c-header--pinned",
						unpinned : "state-c-header--unpinned",
						top : "state-c-header--top",
						notTop : "state-c-header--not-top",
						bottom : "state-c-header--bottom",
						notBottom : "state-c-header--not-bottom"

					}

				});

				headerSticky.init();

			},

			toggle: function( e ) {

				e.preventDefault();

				$( 'html' ).toggleClass( 'state-c-mobile-nav--open' );

			}

		},

		tooltip: {

			init: function() {

				$( document ).on( 'click', '.jsToolTip', PROJECT.tooltip.toggle );

			},

			toggle: function() {

				$( '.a-detail--open' ).not( this ).removeClass( 'a-detail--open' );

				$( this ).toggleClass( 'a-detail--open' );

			}

		},

		accordion: {

			init: function() {

				$( document ).on( 'click', '.jsAccordionToggle', {

					class: 'v-accordion--open',
					classElement: '.jsAccordionItem',
					navElement: '.jsAccordionText',

				}, PROJECT.accordion.toggle );

			},

			toggle: function ( e ) {

				e.preventDefault();

				if ( e.data.classElement !== undefined ) {

					var parent = $( this ).closest( e.data.classElement );

				} else {

					var parent = $( this );

				}

				if ( !$( parent ).hasClass( e.data.class ) ) {

					$( parent ).addClass( e.data.class );

					if ( e.data.navElement !== '' ) {

						$( parent ).find( e.data.navElement ).slideDown( 250 );

					}

				} else {

					$( parent ).removeClass( e.data.class );

					if ( e.data.navElement !== '' ) {

						$( parent ).find( e.data.navElement ).slideUp( 250 );

					}

				}

			},

		},

		gform: {

			init: function() {

				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );
				$( document ).on( 'click.loader', '.gform_button', PROJECT.gform.showLoader );

				$( document ).on( 'click.loader', '.gform_next_button, gform_previous_button', PROJECT.gform.showLoader );
				$( document ).on( 'gform_page_loaded', PROJECT.gform.hideLoader );


				$( document ).on( 'gform_confirmation_loaded', PROJECT.gform.showConfirmation );
				$( document ).on( 'click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation );


				$( document ).on( 'input focus change keydown', 'input, textarea, select', PROJECT.gform.addFocus );

				$( document ).on( 'blur', 'input, textarea, select', PROJECT.gform.removeFocus );

				PROJECT.gform.initFocus();

				PROJECT.gform.addInfoBox();

			},

			initFocus: function() {

				$( 'input, textarea, select' ).each( function() {

					if ( $(this).val() ) {

						$( this ).parents( '.gfield, .a-field' ).addClass( 'state--has-focus' );
	
					}

				});
				
			},

			addFocus: function( e ) {
				
				$( this ).parents( '.gfield, .a-field' ).addClass( 'state--has-focus' );

			},

			removeFocus: function( e ) {

				if( !$(this).val() ) {

					$( this ).parents( '.gfield, .a-field' ).removeClass( 'state--has-focus' );

				}

			},

			showLoader: function() {

				$( '.gformLoader' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideLoader: function( e ) {

				$( '.gformLoader' ).fadeOut( 300 );

				PROJECT.gform.initFocus();
				PROJECT.gform.addInfoBox();

			},

			showConfirmation: function() {

				$( '.gformConfirmation' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideConfirmation: function() {

				$( '.gformConfirmation' ).fadeOut( 300 );

			},

			addInfoBox: function() {

				$( '.gfield_description:not(.validation_message)' ).each( function() {

					var $this = $(this);
					var $gfield = $this.closest('.gfield');
					var $label = $gfield.find('.gfield_label');
					var $infoIcon = $gfield.find('.infoBoxIcon');

					if ( $infoIcon.length === 0 ) {

						//$label.append('<span class="gfield__info-icon infoBoxIcon"><svg viewBox="0 0 20 20"><path d="M10,0A10,10,0,1,1,0,9.91,10,10,0,0,1,10,0Zm.05,1.89a8.1,8.1,0,1,0,8,8.07A8.08,8.08,0,0,0,10.08,1.89Z"/><path d="M9.14,15.83h-.8l-.05,0a1,1,0,0,1-.62-1.2c.37-1.45.74-2.89,1.1-4.34a4.1,4.1,0,0,0,.11-.61.13.13,0,0,0,0-.14.14.14,0,0,0-.15,0,1.06,1.06,0,0,0-.25.09l-.55.23a.31.31,0,0,1-.39-.08V9.45A2.67,2.67,0,0,1,7.92,9C8.47,8.56,9,8.16,9.6,7.76A1.88,1.88,0,0,1,10,7.58a.93.93,0,0,1,.57-.06,1.14,1.14,0,0,1,.79.48,1,1,0,0,1,.12.89c-.36,1.4-.71,2.79-1.07,4.18a5,5,0,0,0-.12.69.12.12,0,0,0,.05.14.16.16,0,0,0,.15,0,3.2,3.2,0,0,0,.39-.16l.48-.18a.25.25,0,0,1,.27.08.21.21,0,0,1,0,.27,1.14,1.14,0,0,1-.15.23,4,4,0,0,1-.43.39,12.8,12.8,0,0,1-1.91,1.29Z"/><path d="M10.43,6.67A1.27,1.27,0,0,1,9.26,5.9a1.25,1.25,0,1,1,2.41-.48,1.25,1.25,0,0,1-1.24,1.25Z"/></svg></span>');
						$label.closest('.gfield').append('<span class="gfield__info-icon infoBoxIcon"> <span>i</span> </span>');
						$infoIcon = $gfield.find('.infoBoxIcon');

					}

					$infoIcon.off('click.toggleInfoBox');
					$infoIcon.on('click.toggleInfoBox', function( e ) {

						e.preventDefault();

						if ( $gfield.hasClass('gfield--infobox-open') ) {

							$gfield.removeClass('gfield--infobox-open');
							$('body').off('click.toggleInfoBox');

						} else {

							$gfield.addClass('gfield--infobox-open');

							setTimeout( function() {

								$('body').on('click.toggleInfoBox', function(e) {

									$gfield.removeClass('gfield--infobox-open');
									$('body').off('click.toggleInfoBox');

								});

							}, 500);

						}

					});

				} );

			}

		},
  
		lightbox : {

			prevUrl: '',

			init: function() {

				$( document ).on( 'click', 'body', PROJECT.lightbox.outerClose );
				$( document ).on( 'click', '.lightboxClose', PROJECT.lightbox.close );
				PROJECT.lightbox.initStoryLightbox();

				$( '.lightboxElement' ).delay( 10000 ).fadeIn( 300 );
			},
			
			initStoryLightbox: function() {
				
				$( document ).off( 'click.openStoryLightbox', '.jsStoryLightbox' );
				$( document ).on( 'click.openStoryLightbox', '.jsStoryLightbox', PROJECT.lightbox.openStoryLightbox );
				
			},

			openStoryLightbox: function( e ) {

				e.preventDefault();
				var $buttonElm = $(this);
				var post_id = $buttonElm.data('id');
				var classes = $buttonElm.data('classes');
				
				if ( typeof classes === 'undefined' || classes === null ) {
					
					classes = '';
					
				}
				
				if ( (typeof post_id !== 'undefined' && post_id !== '' && post_id !== null ) ) {

					PROJECT.lightbox.openAjaxLightbox( 'get_story', {
						post: post_id
					}, classes );

				}
				
				return false;

			},

			open: function( src, style, data, template, cssClass, after ) {
				
				PROJECT.lightbox.close();

				$.get( template, function( template ) {

					var templateRendered = Mustache.render( template, {

						src: src,
						style: style,
						classes: cssClass,
						data: data

					});

					var $lightbox = $( $.parseHTML( templateRendered ) );

					$( 'body' ).append( $lightbox );

					$lightbox.fadeIn(150, function() {
						
						$( 'html' ).addClass( 'state-v-lightbox--open' );
						$lightbox.addClass('v-lightbox--visible');
						
					});

					if ( typeof after == "function") {

						after( $lightbox );

					}

				});

			},

			close: function( e ) {

				$( 'html' ).removeClass( 'state-v-lightbox--open' );
				$( '.lightboxElement' ).fadeOut( 300, function() {

					$( this ).remove();

					if ( PROJECT.lightbox.prevUrl != '' ) {

						history.pushState( {}, '', PROJECT.lightbox.prevUrl );

						PROJECT.lightbox.prevUrl = '';

					}

				});

			},

			outerClose: function( e ) {

				var lightbox_box = $( '.lightboxBox' );

				if ( !lightbox_box.is(e.target) && lightbox_box.has(e.target).length === 0 ) {

					PROJECT.lightbox.close();

				}

			},

			openAjaxLightbox: function( action, data, classes ) {

				var template = tabs_globals.ajaxTemplate;
				var cssClass = 'v-lightbox--ajax';

				var ajaxData = {};

				if ( typeof data === 'object' ) {

					ajaxData = data;

				}

				if ( typeof classes !== 'undefined' ) {

					cssClass = cssClass + ' ' + classes;

				}

				ajaxData.action = action;

				PROJECT.lightbox.open( '', '', '', template, cssClass, function( lightbox ) {

					$.get(tabs_globals.ajaxurl, ajaxData, function( data ) {

						data = JSON.parse( data );

						$( lightbox ).find( '.lightboxAjaxContent' ).fadeOut(1);

						$( lightbox ).find( '.lightboxLoader' ).fadeOut( 200, function() {

							$( lightbox ).find( '.lightboxAjaxContent' ).html( data.html );
							$( lightbox ).find( '.lightboxAjaxContent' ).fadeIn(150);

							/*
							// Only needed for gforms
							var $formWrapper = $( lightbox ).find( '.ajaxForm' );

							if ( $formWrapper.length > 0 ) {

								var formID = $formWrapper.data('form');
								var postID = $formWrapper.data('post');

								//PROJECT.forms.load_form( , $formWrapper );

								var form = PROJECT.forms.load_form( formID, $formWrapper, postID );

								$formWrapper.html(form);

							}
							*/

						});

					});

				});

			}

		},

		video : {

			init: function () {

				$( document ).on( 'click.videoOpen', '.videoOpen', PROJECT.video.open );

			},

			open: function( e ) {

				e.preventDefault();

				var src = $( this ).data( 'video' ) + '&autoplay=true&fun=false&playsinline=true&controls=true';
				var style = $( this ).data( 'video-ratio' );
				var template = $( this ).data( 'template' );
				var cssClass = 'v-lightbox--video';

				if ( style != '' ) {

					style = 'padding-top: ' + style + '%';

				}

				PROJECT.lightbox.open( src, style, {}, template, cssClass );

			}

		},
		
		sliders: {
			
			sliderObjects: [],
		
			init: function() {
				
				PROJECT.sliders.initQuoteSliders();
				PROJECT.sliders.initPostSliders();
				PROJECT.sliders.initCardSliders();
				
			},
			
			initCardSliders: function() {
				
				$( '.jsCarouselCards' ).each( function() {
					
					var $thisSection = $(this);
					var startSlide = 0;
					
					var $swiperWrapper	= $thisSection.find('.jsCardsSlider');
				
					var carouselID		= $thisSection.data( 'object' );
					
					var quotesSwiper	= new Swiper( $swiperWrapper.get( 0 ), {
				
						speed: 500,
						spaceBetween: 40,
						slidesPerView: 'auto',
						centeredSlides: false,
						
						navigation: {
							nextEl: '.jsCardsSliderNext',
							prevEl: '.jsCardsSliderPrev',
						},
						
						breakpoints: {
							// when window width is >= 768px
							768: {
							  slidesPerView: 'auto',
							  spaceBetween: 60
							}
							
						}
						
					});
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( quotesSwiper );
						
						$swiperWrapper.data( 'object', objectID );
						
					}
				
				});
				
			},
			
			initPostSliders: function() {
				
				$( '.jsCarouselPosts' ).each( function() {
					
					var $thisSection = $(this);
					var startSlide = 0;
					var centerSlides = $thisSection.data('center-slides');
					
					if ( typeof centerSlides !== 'undefined' && centerSlides !== null && ( centerSlides === '1' || centerSlides === 1 ) ) {
						
						startSlide = 1;
						
					}
					
					var $swiperWrapper	= $thisSection.find('.jsPostsSlider');
				
					var carouselID		= $thisSection.data( 'object' );
					
					var quotesSwiper	= new Swiper( $swiperWrapper.get( 0 ), {
				
						speed: 500,	// this speed needs to be the same as CSS transitions
						spaceBetween: 20,
						slidesPerView: 1,
						centeredSlides: false,
						initialSlide: startSlide,
						
						navigation: {
							nextEl: '.jsPostsSliderNext',
							prevEl: '.jsPostsSliderPrev',
						},
						
						breakpoints: {
							// when window width is >= 768px
							768: {
							  slidesPerView: 1,
							  spaceBetween: 55
							}
							
						}
						
					});
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( quotesSwiper );
						
						$swiperWrapper.data( 'object', objectID );
						
					}
				
				});
				
			},
			
			initQuoteSliders: function() {
				
				$( '.jsCarouselQuotes' ).each( function() {
					
					var $thisSection = $(this);
					
					var $swiperWrapper	= $thisSection.find('.jsQuotesSlider');
					var $sliderNav		= $thisSection.find('.jsQuotesSliderNav');
					var $navItems		= $sliderNav.find('.jsNavItem');
				
					var carouselID		= $thisSection.data( 'object' );
					
					var quotesSwiper	= new Swiper( $swiperWrapper.get( 0 ), {
				
						speed: 500,
						slidesPerView: 1,
						spaceBetween: 40,
						effect: 'fade',
						watchOverflow: true,
						
						on: {
							init: function() {
								
								PROJECT.sliders.updateQuoteSliderNav( $navItems, this.activeIndex );
								
							},
							slideChange : function() {
								
								PROJECT.sliders.updateQuoteSliderNav( $navItems, this.activeIndex );
								
							}
						}
						
					});
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( quotesSwiper );
						
						$swiperWrapper.data( 'object', objectID );
						
					}
					
					$navItems.on( 'click.navQuotesSwiper', function() {
						
						var newIndex = $navItems.index( $(this) );
						quotesSwiper.slideTo( newIndex );
						
					} );
				
				});
				
			},
			
			updateQuoteSliderNav: function( $navItems, index ) {
				
				$navItems.removeClass('s-carousel-quotes__nav-item--active');
				$navItems.eq( index ).addClass('s-carousel-quotes__nav-item--active');
				
			}
			
		},

		scroll: {

			sr: null,

			init: function() {

				PROJECT.scroll.sr = new ScrollReveal({

					scale:	1,
					viewFactor: 0.70,
					duration: 400,
					delay: 0,
					easing: 'ease-out',
					opacity: 0.5

				});

				PROJECT.scroll.sr.reveal( '.jsStructureStep', {

					beforeReveal: function( el ) {

						el.classList.add( 's-structure__step--active' );

					}

				});

				PROJECT.scroll.sr.reveal( '.jsBalanceGraph', {

					beforeReveal: function( el ) {

						el.classList.add( 's-graph-balance__graph--animate' );

					}

				});

			}

		},

		list: {

			init: function() {

				$( document ).on( 'click', '.tabsListToggleFilter', PROJECT.list.toggleFilter );
				
				$( document ).on( 'click', '.tabsListOpenFilters', PROJECT.list.openFilters );
				$( document ).on( 'click', '.tabsListCloseFilters', PROJECT.list.refreshFilters );

				$( document ).on( 'click', '.tabsListToggleSelection', PROJECT.list.toggleSelection );

				$( document ).on( 'click.tabsFilterClose', 'body', PROJECT.list.closeFilter );

				$( document ).on( 'keyup', PROJECT.list.closeFilters );
				
			},

			toggleFilter: function( e ) {

				e.preventDefault();

				PROJECT.list.removeFilterFirst();

				var isOpen = false;
				var viewport = PROJECT.common.getViewport();

				var $filterBox = $( this ).closest( '.s-list__filter' );
				
				if ( $filterBox.hasClass( 's-list__filter--open' ) ) {

					isOpen = true;

				}

				$( '.s-list__filter--open' ).removeClass( 's-list__filter--open' );

				if ( !isOpen || viewport.width < 996 ) {

					$filterBox.addClass( 's-list__filter--open' );

				}
				
			},

			toggleSelection: function( e ) {

				e.preventDefault();

				var $listSection = $( this ).closest( '.tabsListSection' );
				
				$listSection.toggleClass( 's-list--selector-open' );

			},
			
			closeFilter: function( e ) {

				var filterBox = $( '.tabsListCheckboxes' );
				
				if ( !filterBox.is(e.target) && filterBox.has(e.target).length === 0 ) {

					$( '.s-list__filter--open' ).removeClass( 's-list__filter--open' );

				}

				$( document ).off( 'click.closeListFilter', 'body' );

			},

			removeFilterFirst: function() {

				$( '.s-list--init' ).removeClass( 's-list--init' );

			},
			
			refreshFilters: function( e ) {
				
				e.preventDefault();

				$( 'html' ).removeClass( 'state-s-list--toggle-filters' );

			},

			openFilters: function( e ) {
			
				e.preventDefault();

				$( 'html' ).addClass( 'state-s-list--toggle-filters' );
			
			},

			closeFilters: function( e ) {
			
				if ( e.keyCode === 27 ) {
			
					PROJECT.list.refreshFilters( e );
			
				}

			},

		},

		account: {

			init: function() {

				$( document ).on( 'click', '.jsLogout', PROJECT.account.logoutUser );

				$( document ).on( 'submit', '.jsLoginForm', PROJECT.account.loginUser );

				$( document ).on( 'submit', '.jsResetPasswordForm', PROJECT.account.resetPassword );

			},

			logoutUser: function( e ) {

		    	e.preventDefault();

				PROJECT.loader.show();

				$.ajax({

					type: 'POST',
					url: ajax_object.ajaxurl,
					data: {

						action: 'ajax_logout'

					},
					success: function( data ) {

						location.reload();

					}

				});

			},

			loginUser : function( e ) {

				e.preventDefault();

				var form = this;

				$( '.jsFormError', form ).slideUp( 300 );
				$( '.jsFormSuccess', form ).slideUp( 300 );

				PROJECT.loader.show();

				var loginUsername = $( '#login_email', form ).val();
				var loginPassword = $( '#login_password', form ).val();
				var loginBack = $( '#login_back', form ).val();

				//var loginRecaptcha = $( '#g-recaptcha-response', form ).val();

				$.post( ajax_object.ajaxurl, {

					action: 'ajax_login',

					login_username: loginUsername,
					login_password: loginPassword,

					//login_recaptcha: loginRecaptcha

				}, function(data) {

					var data = $.parseJSON( data );
					
					var error = data.error;
					var errorMsg = data.errorMsg;
					
					$( form ).parent().addClass( 'v-account-form--has-notice' );

					if ( error ) {
						
						PROJECT.loader.hide();
						
						$( '.jsFormError', form ).hide();
						$( '.jsFormError span', form ).text( errorMsg );
						$( '.jsFormError', form ).slideDown( 300 );
						
					} else {
						
						$( '.jsFormSuccess', form ).hide();
						$( '.jsFormSuccess span', form ).text( errorMsg );
						$( '.jsFormSuccess', form ).slideDown( 300 );

						if ( loginBack != undefined && loginBack != '' ) {

							window.location.href = loginBack;

						} else {

							location.reload();

						}
						
					}

				});

	    	},

	    	resetPassword : function( e ) {

				e.preventDefault();

				var form = this;

				$( '.jsFormError', form ).slideUp( 300 );
				$( '.jsFormSuccess', form ).slideUp( 300 );

				var resetEmail = $( '#resetpassword_email', form ).val();
				
				PROJECT.loader.show();

				$.post(ajax_object.ajaxurl, {

					action: 'ajax_reset_password',
					reset_email: resetEmail

				}, function(data) {

					var data = $.parseJSON( data );

					var error = data.error;
					var errorMsg = data.errorMsg;

					if ( error ) {

						

						$( '.jsFormError', form ).text( errorMsg ).hide().slideDown( 300 );

					} else {

						$( '.jsFormSuccess', form ).text( errorMsg ).hide().slideDown( 300 );

					}

					PROJECT.loader.hide();

				});

	    	}

		},

		login: {

			init: function() {

				$( document ).on( 'click', '.jsLoginTabSwitch', PROJECT.login.switch );

			},

			switch: function( e ) {

				e.preventDefault();

				var parent = PROJECT.login.getParent( this );
				
				$( parent ).toggleClass( 's-login--lostpassword' );

			},

			getParent: function( e ) {

				var parent = $( e ).closest( '.jsLogin' );

				return parent;

			}

		},

		talent: {

			doingSave: false,

			init: function() {

				$( document ).on( 'click', '.jsOpenTalent', PROJECT.talent.openOnClick );

				PROJECT.talent.openOnLoad();

				$( document ).on( 'click', '.jsTalentSave', PROJECT.talent.save );
				$( document ).on( 'click', '.jsTalentClear', PROJECT.talent.clear );
				$( document ).on( 'click', '.jsTalentAdd', PROJECT.talent.toggle );

				PROJECT.talent.initSort();

				$( document ).on( 'click', '.jsOpenInfobox', PROJECT.talent.openInfobox );
				$( document ).on( 'click', 'body', PROJECT.talent.closeInfobox );

			},

			initSort: function() {

				var $lists = $( '.jsTalentSelectionList' );

				$lists.each( function() {

					var sortable = Sortable.create( $( this ).get( 0 ), {

						handle: '.jsTalentItemHandle',

						onUpdate: function ( e ) {
							
							var $selectionBox = PROJECT.talent.getSelectionParent( e.target );

							PROJECT.talent.reNumber( $selectionBox );

							PROJECT.talent.realSave( $selectionBox );

						},

					});

				});
				
			},

			openOnClick: function( e ) {

				e.preventDefault();

				var talentHref = $( this ).attr( 'data-link' );
				var parentHref = ajax_object.talentPage;
 
				PROJECT.talent.open( talentHref, parentHref );

			},

			openOnLoad: function() {

				var currentHref = window.location.href;
				var parentHref = ajax_object.talentPage;
				
				if ( currentHref.indexOf( parentHref ) == 0 && parentHref.length != currentHref.length && !currentHref.includes( '?' ) ) {

					PROJECT.talent.open( currentHref, parentHref );

				}
				
			},

			open: function( talentHref, parentHref ) {

				var template = ajax_object.lightboxTemplateTalent;
				var cssClass = 'v-lightbox--talent';
				
				PROJECT.lightbox.prevUrl = parentHref;

				PROJECT.lightbox.open( '', '', { loader : ajax_object.lightboxLoader }, template, cssClass, function( lightbox ) {

					history.pushState( {}, '', talentHref );

					$.get(ajax_object.ajaxurl, {

						action	:	'load_talent',
						talent	:	talentHref
	
					}, function( data ) {

						data = JSON.parse( data );

						$( lightbox ).find( '.lightboxLoader' ).fadeOut( 200, function() {

							$( lightbox ).find( '.lightboxBox' ).html( data.html ).css( 'display', 'none' ).slideDown( 200 );

						});

					});

				});

			},

			getSelectionParent: function( element ) {

				return $( element ).closest( '.jsTalentSelection' );

			},

			save: function( e ) {

				e.preventDefault();

				var $parent = PROJECT.talent.getSelectionParent( this );

				PROJECT.talent.realSave( $parent );

			},

			realSave: function( $parent ) {

				if ( PROJECT.talent.doingSave && PROJECT.talent.doingSave !== 4 ) {

					PROJECT.talent.doingSave.abort();

				}

				PROJECT.talent.showLoader( $parent );

				var selection = [];
				var $items = $parent.find( '.jsTalentItem' );

				if ( $items.length > 0 ) {

					$items.each( function() {

						var $talentID = $( this ).data( 'talent' );

						selection.push( $talentID );

					});

				}

				if ( selection.length == 0 ) {

					selection = 'empty';

				}

				PROJECT.talent.doingSave = $.ajax({

					type: 'POST',
					url: ajax_object.ajaxurl,
					data: {

						action:		'save_selection',
						selection:	selection

					},
					success: function( data ) {

						data = JSON.parse( data );

						PROJECT.talent.hideLoader( $parent );

					}

				});

			},

			clear: function( e ) {

				e.preventDefault();

				var $parent = PROJECT.talent.getSelectionParent( this );

				PROJECT.talent.showLoader( $parent );
				
				$.ajax({

					type: 'POST',
					url: ajax_object.ajaxurl,
					data: {

						action:		'clear_selection'

					},
					success: function( data ) {

						data = JSON.parse( data );

						if ( data.result == true ) {
							
							var $items = $parent.find( '.jsTalentItem' );

							if ( $items.length > 0 ) {

								$items.each( function() {

									$( this ).parent().slideUp( 200, function() {

										$( this ).remove();

										PROJECT.talent.reNumber( $parent );

									} );

								});

							}

						}

						PROJECT.talent.hideLoader( $parent );

						var $listSection = $parent.closest( '.tabsListSection' );
							$listSection.find( '.a-button-add--added' ).removeClass( 'a-button-add--added' );

					}

				});

			},

			toggle: function( e ) {

				e.preventDefault();

				var talentID = $( this ).data( 'talent' );

				if ( typeof talentID !== 'undefined' && talentID != '' ) {

					var $selectionList = $( '.jsTalentSelectionList' );
					var $selectionBox = PROJECT.talent.getSelectionParent( $selectionList );

					if ( PROJECT.talent.isInList( talentID, $selectionList ) ) {

						// if already in list, remove

						$( this ).removeClass( 'a-button-add--added' );

						var $itemsToRemove = $selectionList.find( '.jsTalentItem[data-talent="' + talentID + '"]' );
						
						if ( $itemsToRemove.length > 0 ) {
							
							$itemsToRemove.each( function() {

								$( this ).parent().slideUp( 200, function() {

									$( this ).remove();

									PROJECT.talent.realSave( $selectionBox );
									PROJECT.talent.reNumber( $selectionBox );

								} );

							});

						}

					} else {

						// else add to list

						var $card = $( this ).closest( '.jsTalentToClone' );
						var $card_clone = $card.clone().addClass( 'v-card-talent--small jsTalentItem' ).removeClass( 'v-card-talent--to-clone' );
							$card_clone.attr( 'data-talent', talentID );
						
						var $listItem = $( '<li class="v-list-selection__item"><div class="v-list-selection__handle jsTalentItemHandle"></div></li>' );
							$listItem.prepend( $card_clone[0].outerHTML );

							$listItem.appendTo( $selectionList );
						
						$( this ).addClass( 'a-button-add--added' );

						PROJECT.talent.realSave( $selectionBox );
						PROJECT.talent.reNumber( $selectionBox );

					}

				}

			},

			isInList: function( talentID, $parent ) {

				var returnResult = false;

				var $items = $parent.find( '.jsTalentItem' );
				
				if ( $items.length > 0 ) {

					$items.each( function() {

						var itemTalentID = $( this ).data( 'talent' );
						
						if ( talentID == itemTalentID ) {
							
							returnResult = true;

						}

					});

				}

				return returnResult;

			},

			reNumber: function( $parent ) {

				var itemNo = 1;

				var $items = $parent.find( '.jsTalentItem' );
				
				if ( $items.length > 0 ) {

					$items.each( function() {

						$( this ).find( '.jsTalentItemNo' ).text( itemNo + '.' );

						itemNo++;

					});

					var $itemsTotal = '(' + $items.length + ')'; 

				} else {

					var $itemsTotal = '';

				}

				$parent.find( '.jsTalentSelectionCount' ).text( $itemsTotal );

				$parent.find( '.jsTalentPlaceholder .jsTalentItemNo' ).text( itemNo + '.' );

			},

			showLoader: function( $parent ) {

				$parent.addClass( 'v-list-selection--loading' );

			},

			hideLoader: function( $parent ) {

				$parent.removeClass( 'v-list-selection--loading' );

			},

			openInfobox: function( e ) {

				e.preventDefault();

				$( '.a-leaf-infobox--open-infobox' ).removeClass( 'a-leaf-infobox--open-infobox' );

				var $card = $( this ).closest( '.v-card-talent' );

				if ( $card.length > 0 ) {

					$card.find( '.a-leaf-infobox' ).addClass( 'a-leaf-infobox--open-infobox' );

				} else {
					
					$( this ).find( '.a-leaf-infobox' ).addClass( 'a-leaf-infobox--open-infobox' );

				}

			},

			closeInfobox: function( e ) {

				var card_box = $( '.v-card-talent' );
				var info_box = $( '.jsInfobox' );
	
				if ( ( !card_box.is(e.target) && card_box.has(e.target).length === 0 ) && !info_box.is(e.target) && info_box.has(e.target).length === 0 ) {

					$( '.a-leaf-infobox--open-infobox' ).removeClass( 'a-leaf-infobox--open-infobox' );

				}

			}

		},

		price: {

			init: function( ) {

				$( document ).on( 'click', '.jsOpenPrice', PROJECT.price.openOnClick );

			},

			openOnClick: function( e ) {

				e.preventDefault();
 
				PROJECT.price.open();

			},

			open: function () {

				var template = ajax_object.lightboxTemplateTalent;
				var cssClass = 'v-lightbox--talent-price';

				PROJECT.lightbox.open( '', '', { loader : ajax_object.lightboxLoader }, template, cssClass, function( lightbox ) {

					//history.pushState( {}, '', talentHref );

					$.get(ajax_object.ajaxurl, {

						action	:	'load_talent_price',
	
					}, function( data ) {

						data = JSON.parse( data );

						$( lightbox ).find( '.lightboxLoader' ).fadeOut( 200, function() {

							$( lightbox ).find( '.lightboxBox' ).html( data.html ).css( 'display', 'none' ).slideDown( 200 );

						});

					});

				});

			}

		},

		loader: {

			element: '.jsCoreLoader',

			show: function() {

				$( PROJECT.loader.element ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hide: function() {

				$( PROJECT.loader.element ).fadeOut( 300 );

			}

		},

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);

});

